import { IconButton, Menu, MenuItem } from "@mui/material";
import { FC, useState } from "react";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { SvgIconComponent } from '@mui/icons-material';
import React from "react";
import { Link } from "react-router-dom";

interface IButtonActionMenuOption {
        onClick?: (data?: any) => void;
        href?: string;
        openInNewTab?: boolean;
        title: string;
        icon?: React.ReactNode;
        titleColor?: string;
}

interface IButtonActionMenuProps {
    options: IButtonActionMenuOption[];
    iconColor?: string;
    titleColor?: string;
    defaultIcon?: SvgIconComponent;
    menuPosition?: 'left' | 'right';
    customMenu?: React.ReactNode | ((handleOpenMenu: (event: React.MouseEvent<HTMLElement>) => void) => React.ReactNode);
}

const ButtonActionMenu : FC<IButtonActionMenuProps> = ({ 
    options, 
    iconColor = 'inherit',
    titleColor = 'inherit',
    defaultIcon = MoreVertIcon,
    menuPosition = 'left',
    customMenu
}) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };
  
    return (
      <>
        {customMenu ? (
          typeof customMenu === 'function' 
            ? customMenu(handleOpenMenu)
            : React.cloneElement(customMenu as React.ReactElement, { onClick: handleOpenMenu })
        ) : (
          <IconButton onClick={handleOpenMenu}>
            {React.createElement(defaultIcon, { sx: { color: iconColor } })}
          </IconButton>
        )}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'top',
            horizontal: menuPosition,
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: menuPosition,
          }}
        >
            {options.map((item, index) => {
                if (item.href) {
                    return (
                        <MenuItem
                            key={index}
                            component={Link}
                            to={item.href}
                            target={item.openInNewTab ? '_blank' : undefined}
                            rel={item.openInNewTab ? 'noopener noreferrer' : undefined}
                            onClick={handleCloseMenu}
                            sx={{ color: item.titleColor || titleColor }}
                        >
                            {item.icon && <span style={{ marginRight: 8 }}>{item.icon}</span>}
                            {item.title}
                        </MenuItem>
                    );
                }

                return (
                    <MenuItem 
                        key={index}
                        onClick={(e) => {
                            item.onClick?.(e)
                            handleCloseMenu()
                        }}
                        sx={{ color: item.titleColor || titleColor }}
                    >
                        {item.icon && <span style={{ marginRight: 8 }}>{item.icon}</span>}
                        {item.title}
                    </MenuItem>
                );
            })}
        </Menu>
      </>
    );
};

export { ButtonActionMenu };